<div class="content">
    <div id="topSection" [attr.data-automation-id]="modalAutomationId + '-connector-table-container'">
        <res-generic-grid id="connectorGrid" [gridName]="gridName" [automationId]="gridAutomationId"
            [updateStatusType]="updateStatusType" [(isBusy)]="isGridBusy" [(isBusyMessage)]="isGridBusyMessage"
            [columnDefs]="columnDefs" [requestInfo]="requestInfo" [responseCallback]="responseCallback"
            [pagerVisible]="false" [onSelectionChanged]="connectorOnSelectionChanged"
            [rowSelection]="connectorSelection" [gridContext]="connectorsGridContext">
        </res-generic-grid>
    </div>

    <res-resizer anchor="up" ellipsisExpander="true" resizingElementId="topSection" secondElementId="bottomSection"
        [collapsible]="false" [initSize]="50" [usePercentages]="true"></res-resizer>

    <div id="bottomSection">
        <div class="no-connector-data" [hidden]="!showTreeGridPlaceholder">
            <span class="noTreeInfo">
                <div class="hint-popover">
                    <i class="fa fa-arrow-up"></i>Please select a connector</div>
            </span>
        </div>

        <div id="treeSection" [hidden]="showTreeGridPlaceholder" [resBusySpinner]="isPathsBusy"
            message="Loading Paths ...">
            <div class="section-heading">
                <span>{{ treeHeaderText }}</span>
            </div>
            <res-generic-tree [automationId]="modalAutomationId + '-tree'" [loadNodeDataCallback]="loadNodeDataCallback"
                [selectedNodeChangedCallback]="selectedNodeChangedCallback"></res-generic-tree>
        </div>

        <res-resizer [hidden]="showTreeGridPlaceholder" anchor="left" resizingElementId="treeSection"
            secondElementId="gridSection" [initSize]="40" [minSize]="20" [maxSize]="40" [usePercentages]="true"
            [attr.data-automation-id]="modalAutomationId + '-resizer-button'" [ellipsisExpander]="true"></res-resizer>

        <div id="gridSection" [hidden]="showTreeGridPlaceholder">
            <res-generic-grid #filesGrid [automationId]="fileGridAutomationId"
                [updateStatusType]="filesGridUpdateStatusType" [rowSelection]="filesGridRowSelection"
                [pagerVisible]="false" [(isBusy)]="isFilesBusy" [(isBusyMessage)]="isFilesBusyMessage"
                [columnDefs]="filesGridColumnDefs" [requestInfo]="fileGridRequestInfo"
                [responseArrayFilter]="filesGridResponseArrayFilter" [onSelectionChanged]="filesGridOnSelectionChanged"
                [gridContext]="filesGridContext">
            </res-generic-grid>
            <div class="file-grid-path-container">
                <label for="filePathInput">Path:</label>
                <input type="text" name="filePath" id="filePathInput" [(ngModel)]="selectedFile.handle" readonly
                    [attr.data-automation-id]="modalAutomationId + '-path-input'" />
            </div>
        </div>
    </div>
</div>